import { BizCardsRoutingService } from '@client/services/bizcards-routing';

// Truthy with no >=400 status is success; a cancelled request resolves undefined.
const ok = (res) => !!res && !(res.status >= 400);

/**
 * Builds the save payload for one route, mirroring the single-route `onSave()`
 * in `route/route.svelte`. Unlike the signature endpoint this one takes the
 * priority as displayed, and the routes carry no tags.
 *
 * @param {Object} route The route as held by the page.
 * @param {Object[]} senderGroups Every group, used to resolve the selected names.
 * @param {boolean} status The status to save.
 * @returns {Object}
 */
export const buildRoutePayload = (route, senderGroups, status) => {
  const selectedGroups = (route.selectedGroups || []).map(({ value }) => value);
  const sendergroups = senderGroups.filter(({ groupname }) => selectedGroups.includes(groupname));
  const { blockname, bizcard = {}, _id } = route;

  return {
    _id,
    bizcard,
    blockname,
    priority: route.priority,
    sendergroups,
    status,
    tags: []
  };
};

/**
 * Keyed by the action strings `RouteSelectionControls` emits, so the page can
 * dispatch with `routeRunners[action]`.
 */
export const routeRunners = {
  enable: async (route, senderGroups) =>
    ok(await BizCardsRoutingService.updateRoute(buildRoutePayload(route, senderGroups, true))),
  disable: async (route, senderGroups) =>
    ok(await BizCardsRoutingService.updateRoute(buildRoutePayload(route, senderGroups, false))),
  delete: async (route) => ok(await BizCardsRoutingService.deleteRoute(route))
};
